import "./PopUpDialog.css";

import classNames from "classnames";
import { MouseEventHandler, ReactChild } from "react";

import Spinner from "components/Spinner";

const PopUpDialog = ({
  children,
  onClose,
  title,
  dialogStatus,
  type = "default",
}: {
  children: ReactChild;
  onClose: MouseEventHandler<HTMLDivElement>;
  title: string;
  dialogStatus?: "loading" | "success";
  type?: "default" | "alert" | "warning";
}) => {
  return (
    <>
      <div className="PopUpDialog__screenCancel" onClick={onClose} />
      <div className="PopUpDialog">
        <h1
          className={classNames("PopUpDialog__header", {
            "PopUpDialog__header--alert": type === "alert",
            "PopUpDialog__header--warning": type === "warning",
          })}
        >
          {title}
        </h1>
        <div className="PopUpDialog__container">
          {dialogStatus === "loading" && (
            <div className="PopUpDialog__spinner">
              <Spinner />
            </div>
          )}
          {children}
        </div>
      </div>
    </>
  );
};

export default PopUpDialog;
